import React, { Component } from "react";
import RegistrationLink from "./RegistrationLink";

class AddTask extends Component {
  constructor() {
    super();
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(e) {
    e.preventDefault();
    const { match, users } = this.props;
    const id = Number(match.params.id);
    const taskName = e.target.elements.taskName.value;
    // const taskStatus = e.target.elements.taskStatus.value;
    const assignedBy = e.target.elements.assignedBy.value;
    const taskStatus = "Open";
    const createdAt = new Date();
    this.props.startAddingTask(taskName, taskStatus, assignedBy, createdAt, id);
    e.target.elements.taskName.value = "";
    this.props.startLoadingTasks();
    this.props.history.push(`/single/${id}`);
  }

  render() {
    if (this.props.auth.authenticated === false) {
      return <RegistrationLink />;
    }
    return (
      <form className="form-inline" onSubmit={this.handleSubmit}>
        <input
          className="form-control mr-2"
          type="text"
          name="taskName"
          placeholder="Enter Task"
          required
          autoFocus
        />
        <select className="form-control select2" name="assignedBy">
          {this.props.users.map((user, index) => {
            return <option key={index}>{user.userName}</option>;
          })}
        </select>
        {/*<input
          className="form-control mr-2"
          type="text"
          name="taskStatus"
          placeholder="Task Status"
    />*/}
        <button className="btn btn-primary" type="submit">
          Submit
        </button>
      </form>
    );
  }
}

export default AddTask;
